// 🤖 Virtual Assistant - Asistente Virtual Principal
import { useState } from 'react';
import { AssistantBubble } from './AssistantBubble';
import { AssistantChat } from './AssistantChat';
import { useAssistant } from '@/lib/hooks/useAssistant';
import { useAssistantStore } from '@/stores/assistant.store';
import { useAuth } from '@/lib/hooks';

export function VirtualAssistant() {
  const enabled = useAssistantStore((s) => s.enabled);
  const { isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(1); // Mostrar badge inicial

  const {
    messages,
    isProcessing,
    suggestions,
    currentModule,
    processMessage,
  } = useAssistant();

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      // Marcar notificaciones como vistas al abrir
      setNotificationCount(0);
    }
  };

  const handleSendMessage = async (message: string) => {
    await processMessage(message);
  };

  // No renderizar sin sesión (p.ej. en la pantalla de login) ni si se deshabilitó desde el Header.
  if (!enabled || !isAuthenticated) return null;

  return (
    <>
      <AssistantBubble
        isOpen={isOpen}
        onToggle={handleToggle}
        notificationCount={notificationCount}
      />

      <AssistantChat
        isOpen={isOpen}
        messages={messages}
        onSendMessage={handleSendMessage}
        onClose={() => setIsOpen(false)} // ← Agregado
        isProcessing={isProcessing}
        suggestions={suggestions}
        currentContext={currentModule}
      />
    </>
  );
}
